import { render, staticRenderFns } from "./edit-speak-modal.vue?vue&type=template&id=0e0f2663&scoped=true"
import script from "./edit-speak-modal.vue?vue&type=script&lang=js"
export * from "./edit-speak-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-speak-modal.vue?vue&type=style&index=0&id=0e0f2663&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0f2663",
  null
  
)

export default component.exports